import React, { useState } from 'react';
import { beforeAfter } from '../mock/mockData';

export const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="gallery" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">Before & After</h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            See the transformations we've created for our clients
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {beforeAfter.map((item) => (
            <div key={item.id} className="group">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300">
                <div className="relative">
                  {/* Before Image */}
                  <div className="relative overflow-hidden">
                    <img
                      src={item.before}
                      alt="Before"
                      className="w-full h-64 object-cover"
                    />
                    <div className="absolute top-4 left-4 bg-red-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                      Before
                    </div>
                  </div>

                  {/* After Image */}
                  <div className="relative overflow-hidden">
                    <img
                      src={item.after}
                      alt="After"
                      className="w-full h-64 object-cover"
                    />
                    <div className="absolute top-4 left-4 bg-green-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                      After
                    </div>
                  </div>
                </div>

                <div className="p-6">
                  <h3 className="text-lg font-bold text-slate-900 mb-2">{item.description}</h3>
                  <p className="text-blue-600 font-semibold text-sm">{item.package}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Gallery Info */}
        <div className="mt-16 text-center">
          <p className="text-slate-600 mb-6">
            Every garage is unique. We provide custom before/after photos for your records.
          </p>
          <div className="inline-flex items-center space-x-2 bg-blue-50 text-blue-700 px-6 py-3 rounded-full">
            <span className="font-semibold">📸 Professional photography included with Gold & Platinum packages</span>
          </div>
        </div>
      </div>
    </section>
  );
};
